import { DashboardLayout } from '@/backoffice/components/layout';
import { AdminGeographyManager } from '@/backoffice/components/admin/AdminGeographyManager';
import { useAdminContext } from '@/backoffice/hooks/useAdminContext';

export function AdminGeographyPage() {
  const userType = useAdminContext();

  return (
    <DashboardLayout userType={userType} title="Géographie administrative">
      <p className="text-sm text-gray-500 mb-6">
        Gérez le découpage territorial : pays, régions, préfectures, communes, quartiers et secteurs.
        Cliquez sur un élément pour naviguer et ajouter des subdivisions.
      </p>
      <AdminGeographyManager />
    </DashboardLayout>
  );
}
